/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  BillingAddressResponse,
  BillingAddressesResponse,
  BillingEmailResponse,
  BillingEmailsResponse,
  BillingInvoiceResponse,
  BillingInvoicesResponse,
  BillingPaymentMethodResponse,
  BillingPaymentMethodsResponse,
  BillingProductsResponse,
  CreateBillingAddressRequest,
  CreateBillingAddressResponse,
  CreateBillingCreditCardSetupIntentResponse,
  CreateBillingPayPalSubscriptionResponse,
  CreateBillingPaymentMethodRequest,
  DownloadBillingInvoicePdfParams,
  Error,
  FindBillingPaymentMethodParams,
  ListBillingAddressesParams,
  ListBillingEmailsParams,
  ListBillingInvoicesParams,
  ListBillingPaymentMethodsParams,
  ListBillingProductsParams,
  SuccessResponse,
  UpdateBillingAddressRequest,
  UpdateBillingPayMethodRequest,
  UpdateBillingPayPalSubscriptionRequest,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Lists billing addresses on your account and any linked payment methods.
 * @summary List billing addresses
 */
export const listBillingAddresses = (params?: ListBillingAddressesParams, signal?: AbortSignal) => {
  return customFetch<BillingAddressesResponse>({
    url: `/v1/billing/addresses`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListBillingAddressesQueryKey = (params?: ListBillingAddressesParams) => {
  return [`/v1/billing/addresses`, ...(params ? [params] : [])] as const;
};

export const getListBillingAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params?: ListBillingAddressesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingAddressesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingAddresses>>> = ({ signal }) =>
    listBillingAddresses(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/addresses`,
      operationId: 'app.controllers.billing_addresses_controller.list_billing_addresses',
      operationName: 'listBillingAddresses',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listBillingAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingAddressesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingAddresses>>
>;
export type ListBillingAddressesQueryError = Error;

export function useListBillingAddresses<
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params: undefined | ListBillingAddressesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingAddresses>>,
          TError,
          Awaited<ReturnType<typeof listBillingAddresses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingAddresses<
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params?: ListBillingAddressesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingAddresses>>,
          TError,
          Awaited<ReturnType<typeof listBillingAddresses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingAddresses<
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params?: ListBillingAddressesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List billing addresses
 */

export function useListBillingAddresses<
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params?: ListBillingAddressesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingAddressesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListBillingAddressesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params?: ListBillingAddressesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingAddressesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingAddresses>>> = ({ signal }) =>
    listBillingAddresses(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/addresses`,
      operationId: 'app.controllers.billing_addresses_controller.list_billing_addresses',
      operationName: 'listBillingAddresses',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listBillingAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingAddressesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingAddresses>>
>;
export type ListBillingAddressesSuspenseQueryError = Error;

export function useListBillingAddressesSuspense<
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params: undefined | ListBillingAddressesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingAddressesSuspense<
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params?: ListBillingAddressesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingAddressesSuspense<
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params?: ListBillingAddressesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List billing addresses
 */

export function useListBillingAddressesSuspense<
  TData = Awaited<ReturnType<typeof listBillingAddresses>>,
  TError = Error,
>(
  params?: ListBillingAddressesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingAddresses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingAddressesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds a billing contact and address for invoices and payment methods.
 * @summary Add a billing address
 */
export const createBillingAddress = (
  createBillingAddressRequest: CreateBillingAddressRequest,
  signal?: AbortSignal
) => {
  return customFetch<CreateBillingAddressResponse>({
    url: `/v1/billing/addresses`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createBillingAddressRequest,
    signal,
  });
};

export const getCreateBillingAddressMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingAddress>>,
    TError,
    { data: CreateBillingAddressRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingAddress>>,
  TError,
  { data: CreateBillingAddressRequest },
  TContext
> => {
  const mutationKey = ['createBillingAddress'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingAddress>>,
    { data: CreateBillingAddressRequest }
  > = props => {
    const { data } = props ?? {};

    return createBillingAddress(data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/addresses` },
    {
      operationId: 'app.controllers.billing_addresses_controller.create_billing_address',
      operationName: 'createBillingAddress',
    }
  );

  return customOptions;
};

export type CreateBillingAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingAddress>>
>;
export type CreateBillingAddressMutationBody = CreateBillingAddressRequest;
export type CreateBillingAddressMutationError = Error;

/**
 * @summary Add a billing address
 */
export const useCreateBillingAddress = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBillingAddress>>,
      TError,
      { data: CreateBillingAddressRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createBillingAddress>>,
  TError,
  { data: CreateBillingAddressRequest },
  TContext
> => {
  const mutationOptions = getCreateBillingAddressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns one billing address and its associated payment methods.
 * @summary Get a billing address
 */
export const findBillingAddress = (addressId: number, signal?: AbortSignal) => {
  return customFetch<BillingAddressResponse>({
    url: `/v1/billing/addresses/${addressId}`,
    method: 'GET',
    signal,
  });
};

export const getFindBillingAddressQueryKey = (addressId?: number) => {
  return [`/v1/billing/addresses/${addressId}`] as const;
};

export const getFindBillingAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindBillingAddressQueryKey(addressId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findBillingAddress>>> = ({ signal }) =>
    findBillingAddress(addressId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { addressId },
    {
      url: `/v1/billing/addresses/${addressId}`,
      operationId: 'app.controllers.billing_addresses_controller.find_billing_address',
      operationName: 'findBillingAddress',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findBillingAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindBillingAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBillingAddress>>
>;
export type FindBillingAddressQueryError = Error;

export function useFindBillingAddress<
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findBillingAddress>>,
          TError,
          Awaited<ReturnType<typeof findBillingAddress>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingAddress<
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findBillingAddress>>,
          TError,
          Awaited<ReturnType<typeof findBillingAddress>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingAddress<
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a billing address
 */

export function useFindBillingAddress<
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindBillingAddressQueryOptions(addressId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindBillingAddressSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindBillingAddressQueryKey(addressId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findBillingAddress>>> = ({ signal }) =>
    findBillingAddress(addressId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { addressId },
    {
      url: `/v1/billing/addresses/${addressId}`,
      operationId: 'app.controllers.billing_addresses_controller.find_billing_address',
      operationName: 'findBillingAddress',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findBillingAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindBillingAddressSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBillingAddress>>
>;
export type FindBillingAddressSuspenseQueryError = Error;

export function useFindBillingAddressSuspense<
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingAddressSuspense<
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingAddressSuspense<
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a billing address
 */

export function useFindBillingAddressSuspense<
  TData = Awaited<ReturnType<typeof findBillingAddress>>,
  TError = Error,
>(
  addressId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingAddress>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindBillingAddressSuspenseQueryOptions(addressId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates billing contact or address details.
 * @summary Update a billing address
 */
export const modifyBillingAddress = (
  addressId: number,
  updateBillingAddressRequest: UpdateBillingAddressRequest
) => {
  return customFetch<SuccessResponse>({
    url: `/v1/billing/addresses/${addressId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateBillingAddressRequest,
  });
};

export const getModifyBillingAddressMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modifyBillingAddress>>,
    TError,
    { addressId: number; data: UpdateBillingAddressRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modifyBillingAddress>>,
  TError,
  { addressId: number; data: UpdateBillingAddressRequest },
  TContext
> => {
  const mutationKey = ['modifyBillingAddress'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modifyBillingAddress>>,
    { addressId: number; data: UpdateBillingAddressRequest }
  > = props => {
    const { addressId, data } = props ?? {};

    return modifyBillingAddress(addressId, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/addresses/{addressId}` },
    {
      operationId: 'app.controllers.billing_addresses_controller.modify_billing_address',
      operationName: 'modifyBillingAddress',
    }
  );

  return customOptions;
};

export type ModifyBillingAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof modifyBillingAddress>>
>;
export type ModifyBillingAddressMutationBody = UpdateBillingAddressRequest;
export type ModifyBillingAddressMutationError = Error;

/**
 * @summary Update a billing address
 */
export const useModifyBillingAddress = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof modifyBillingAddress>>,
      TError,
      { addressId: number; data: UpdateBillingAddressRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof modifyBillingAddress>>,
  TError,
  { addressId: number; data: UpdateBillingAddressRequest },
  TContext
> => {
  const mutationOptions = getModifyBillingAddressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Permanently removes a billing address from your account.
 * @summary Delete a billing address
 */
export const deleteBillingAddress = (addressId: number) => {
  return customFetch<SuccessResponse>({
    url: `/v1/billing/addresses/${addressId}`,
    method: 'DELETE',
  });
};

export const getDeleteBillingAddressMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBillingAddress>>,
    TError,
    { addressId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBillingAddress>>,
  TError,
  { addressId: number },
  TContext
> => {
  const mutationKey = ['deleteBillingAddress'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBillingAddress>>,
    { addressId: number }
  > = props => {
    const { addressId } = props ?? {};

    return deleteBillingAddress(addressId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/addresses/{addressId}` },
    {
      operationId: 'app.controllers.billing_addresses_controller.delete_billing_address',
      operationName: 'deleteBillingAddress',
    }
  );

  return customOptions;
};

export type DeleteBillingAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBillingAddress>>
>;

export type DeleteBillingAddressMutationError = Error;

/**
 * @summary Delete a billing address
 */
export const useDeleteBillingAddress = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBillingAddress>>,
      TError,
      { addressId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBillingAddress>>,
  TError,
  { addressId: number },
  TContext
> => {
  const mutationOptions = getDeleteBillingAddressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Lists billing-related emails sent to your account, such as confirmations and receipts.
 * @summary List billing emails
 */
export const listBillingEmails = (params?: ListBillingEmailsParams, signal?: AbortSignal) => {
  return customFetch<BillingEmailsResponse>({
    url: `/v1/billing/emails`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListBillingEmailsQueryKey = (params?: ListBillingEmailsParams) => {
  return [`/v1/billing/emails`, ...(params ? [params] : [])] as const;
};

export const getListBillingEmailsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params?: ListBillingEmailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingEmailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingEmails>>> = ({ signal }) =>
    listBillingEmails(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/emails`,
      operationId: 'app.controllers.billing_controller.list_billing_emails',
      operationName: 'listBillingEmails',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listBillingEmails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingEmailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingEmails>>
>;
export type ListBillingEmailsQueryError = Error;

export function useListBillingEmails<
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params: undefined | ListBillingEmailsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingEmails>>,
          TError,
          Awaited<ReturnType<typeof listBillingEmails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingEmails<
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params?: ListBillingEmailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingEmails>>,
          TError,
          Awaited<ReturnType<typeof listBillingEmails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingEmails<
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params?: ListBillingEmailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List billing emails
 */

export function useListBillingEmails<
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params?: ListBillingEmailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingEmailsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListBillingEmailsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params?: ListBillingEmailsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingEmailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingEmails>>> = ({ signal }) =>
    listBillingEmails(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/emails`,
      operationId: 'app.controllers.billing_controller.list_billing_emails',
      operationName: 'listBillingEmails',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listBillingEmails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingEmailsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingEmails>>
>;
export type ListBillingEmailsSuspenseQueryError = Error;

export function useListBillingEmailsSuspense<
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params: undefined | ListBillingEmailsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingEmailsSuspense<
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params?: ListBillingEmailsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingEmailsSuspense<
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params?: ListBillingEmailsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List billing emails
 */

export function useListBillingEmailsSuspense<
  TData = Awaited<ReturnType<typeof listBillingEmails>>,
  TError = Error,
>(
  params?: ListBillingEmailsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingEmails>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingEmailsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the full content of one billing email, including HTML body.
 * @summary View a billing email
 */
export const findBillingEmail = (emailId: number, signal?: AbortSignal) => {
  return customFetch<BillingEmailResponse>({
    url: `/v1/billing/emails/${emailId}`,
    method: 'GET',
    signal,
  });
};

export const getFindBillingEmailQueryKey = (emailId?: number) => {
  return [`/v1/billing/emails/${emailId}`] as const;
};

export const getFindBillingEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindBillingEmailQueryKey(emailId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findBillingEmail>>> = ({ signal }) =>
    findBillingEmail(emailId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { emailId },
    {
      url: `/v1/billing/emails/${emailId}`,
      operationId: 'app.controllers.billing_controller.find_billing_email',
      operationName: 'findBillingEmail',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findBillingEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindBillingEmailQueryResult = NonNullable<Awaited<ReturnType<typeof findBillingEmail>>>;
export type FindBillingEmailQueryError = Error;

export function useFindBillingEmail<
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findBillingEmail>>,
          TError,
          Awaited<ReturnType<typeof findBillingEmail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingEmail<
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findBillingEmail>>,
          TError,
          Awaited<ReturnType<typeof findBillingEmail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingEmail<
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary View a billing email
 */

export function useFindBillingEmail<
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindBillingEmailQueryOptions(emailId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindBillingEmailSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindBillingEmailQueryKey(emailId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findBillingEmail>>> = ({ signal }) =>
    findBillingEmail(emailId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { emailId },
    {
      url: `/v1/billing/emails/${emailId}`,
      operationId: 'app.controllers.billing_controller.find_billing_email',
      operationName: 'findBillingEmail',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findBillingEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindBillingEmailSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBillingEmail>>
>;
export type FindBillingEmailSuspenseQueryError = Error;

export function useFindBillingEmailSuspense<
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingEmailSuspense<
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingEmailSuspense<
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary View a billing email
 */

export function useFindBillingEmailSuspense<
  TData = Awaited<ReturnType<typeof findBillingEmail>>,
  TError = Error,
>(
  emailId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingEmail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindBillingEmailSuspenseQueryOptions(emailId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Lists invoices with status, amounts, and download links. Filter by status and search.
 * @summary List invoices
 */
export const listBillingInvoices = (params?: ListBillingInvoicesParams, signal?: AbortSignal) => {
  return customFetch<BillingInvoicesResponse>({
    url: `/v1/billing/invoices`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListBillingInvoicesQueryKey = (params?: ListBillingInvoicesParams) => {
  return [`/v1/billing/invoices`, ...(params ? [params] : [])] as const;
};

export const getListBillingInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params?: ListBillingInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingInvoicesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingInvoices>>> = ({ signal }) =>
    listBillingInvoices(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/invoices`,
      operationId: 'app.controllers.billing_invoices_controller.list_billing_invoices',
      operationName: 'listBillingInvoices',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listBillingInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingInvoices>>
>;
export type ListBillingInvoicesQueryError = Error;

export function useListBillingInvoices<
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params: undefined | ListBillingInvoicesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingInvoices>>,
          TError,
          Awaited<ReturnType<typeof listBillingInvoices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingInvoices<
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params?: ListBillingInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingInvoices>>,
          TError,
          Awaited<ReturnType<typeof listBillingInvoices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingInvoices<
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params?: ListBillingInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List invoices
 */

export function useListBillingInvoices<
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params?: ListBillingInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListBillingInvoicesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params?: ListBillingInvoicesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingInvoicesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingInvoices>>> = ({ signal }) =>
    listBillingInvoices(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/invoices`,
      operationId: 'app.controllers.billing_invoices_controller.list_billing_invoices',
      operationName: 'listBillingInvoices',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listBillingInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingInvoicesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingInvoices>>
>;
export type ListBillingInvoicesSuspenseQueryError = Error;

export function useListBillingInvoicesSuspense<
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params: undefined | ListBillingInvoicesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingInvoicesSuspense<
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params?: ListBillingInvoicesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingInvoicesSuspense<
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params?: ListBillingInvoicesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List invoices
 */

export function useListBillingInvoicesSuspense<
  TData = Awaited<ReturnType<typeof listBillingInvoices>>,
  TError = Error,
>(
  params?: ListBillingInvoicesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingInvoices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingInvoicesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns line items, payment status, transactions, and a PDF download link for one invoice.
 * @summary Get invoice details
 */
export const findBillingInvoice = (invoiceId: number, signal?: AbortSignal) => {
  return customFetch<BillingInvoiceResponse>({
    url: `/v1/billing/invoices/${invoiceId}`,
    method: 'GET',
    signal,
  });
};

export const getFindBillingInvoiceQueryKey = (invoiceId?: number) => {
  return [`/v1/billing/invoices/${invoiceId}`] as const;
};

export const getFindBillingInvoiceQueryOptions = <
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindBillingInvoiceQueryKey(invoiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findBillingInvoice>>> = ({ signal }) =>
    findBillingInvoice(invoiceId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { invoiceId },
    {
      url: `/v1/billing/invoices/${invoiceId}`,
      operationId: 'app.controllers.billing_invoices_controller.find_billing_invoice',
      operationName: 'findBillingInvoice',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findBillingInvoice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindBillingInvoiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBillingInvoice>>
>;
export type FindBillingInvoiceQueryError = Error;

export function useFindBillingInvoice<
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findBillingInvoice>>,
          TError,
          Awaited<ReturnType<typeof findBillingInvoice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingInvoice<
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findBillingInvoice>>,
          TError,
          Awaited<ReturnType<typeof findBillingInvoice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingInvoice<
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get invoice details
 */

export function useFindBillingInvoice<
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindBillingInvoiceQueryOptions(invoiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindBillingInvoiceSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindBillingInvoiceQueryKey(invoiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findBillingInvoice>>> = ({ signal }) =>
    findBillingInvoice(invoiceId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { invoiceId },
    {
      url: `/v1/billing/invoices/${invoiceId}`,
      operationId: 'app.controllers.billing_invoices_controller.find_billing_invoice',
      operationName: 'findBillingInvoice',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findBillingInvoice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindBillingInvoiceSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBillingInvoice>>
>;
export type FindBillingInvoiceSuspenseQueryError = Error;

export function useFindBillingInvoiceSuspense<
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingInvoiceSuspense<
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingInvoiceSuspense<
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get invoice details
 */

export function useFindBillingInvoiceSuspense<
  TData = Awaited<ReturnType<typeof findBillingInvoice>>,
  TError = Error,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingInvoice>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindBillingInvoiceSuspenseQueryOptions(invoiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Charges an unpaid invoice using your account's active credit card.
 * @summary Pay invoice with saved card
 */
export const payBillingInvoiceCreditCardPayment = (invoiceId: number, signal?: AbortSignal) => {
  return customFetch<SuccessResponse>({
    url: `/v1/billing/invoices/${invoiceId}/credit_card_payment`,
    method: 'POST',
    signal,
  });
};

export const getPayBillingInvoiceCreditCardPaymentMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payBillingInvoiceCreditCardPayment>>,
    TError,
    { invoiceId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payBillingInvoiceCreditCardPayment>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['payBillingInvoiceCreditCardPayment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payBillingInvoiceCreditCardPayment>>,
    { invoiceId: number }
  > = props => {
    const { invoiceId } = props ?? {};

    return payBillingInvoiceCreditCardPayment(invoiceId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/invoices/{invoiceId}/credit_card_payment` },
    {
      operationId:
        'app.controllers.billing_invoices_controller.pay_billing_invoice_credit_card_payment',
      operationName: 'payBillingInvoiceCreditCardPayment',
    }
  );

  return customOptions;
};

export type PayBillingInvoiceCreditCardPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof payBillingInvoiceCreditCardPayment>>
>;

export type PayBillingInvoiceCreditCardPaymentMutationError = Error;

/**
 * @summary Pay invoice with saved card
 */
export const usePayBillingInvoiceCreditCardPayment = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof payBillingInvoiceCreditCardPayment>>,
      TError,
      { invoiceId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof payBillingInvoiceCreditCardPayment>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationOptions = getPayBillingInvoiceCreditCardPaymentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Confirms a PayPal subscription after checkout completes.
 * @summary Confirm PayPal subscription
 */
export const confirmBillingInvoicePaypalSubscription = (
  invoiceId: number,
  updateBillingPayPalSubscriptionRequest: UpdateBillingPayPalSubscriptionRequest
) => {
  return customFetch<SuccessResponse>({
    url: `/v1/billing/invoices/${invoiceId}/paypal_subscription`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateBillingPayPalSubscriptionRequest,
  });
};

export const getConfirmBillingInvoicePaypalSubscriptionMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmBillingInvoicePaypalSubscription>>,
    TError,
    { invoiceId: number; data: UpdateBillingPayPalSubscriptionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmBillingInvoicePaypalSubscription>>,
  TError,
  { invoiceId: number; data: UpdateBillingPayPalSubscriptionRequest },
  TContext
> => {
  const mutationKey = ['confirmBillingInvoicePaypalSubscription'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmBillingInvoicePaypalSubscription>>,
    { invoiceId: number; data: UpdateBillingPayPalSubscriptionRequest }
  > = props => {
    const { invoiceId, data } = props ?? {};

    return confirmBillingInvoicePaypalSubscription(invoiceId, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/invoices/{invoiceId}/paypal_subscription` },
    {
      operationId:
        'app.controllers.billing_invoices_controller.confirm_billing_invoice_paypal_subscription',
      operationName: 'confirmBillingInvoicePaypalSubscription',
    }
  );

  return customOptions;
};

export type ConfirmBillingInvoicePaypalSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmBillingInvoicePaypalSubscription>>
>;
export type ConfirmBillingInvoicePaypalSubscriptionMutationBody =
  UpdateBillingPayPalSubscriptionRequest;
export type ConfirmBillingInvoicePaypalSubscriptionMutationError = Error;

/**
 * @summary Confirm PayPal subscription
 */
export const useConfirmBillingInvoicePaypalSubscription = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmBillingInvoicePaypalSubscription>>,
      TError,
      { invoiceId: number; data: UpdateBillingPayPalSubscriptionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof confirmBillingInvoicePaypalSubscription>>,
  TError,
  { invoiceId: number; data: UpdateBillingPayPalSubscriptionRequest },
  TContext
> => {
  const mutationOptions = getConfirmBillingInvoicePaypalSubscriptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Starts PayPal subscription setup for an invoice. Returns a plan ID for the PayPal checkout button.
 * @summary Start PayPal subscription checkout
 */
export const createBillingInvoicePaypalSubscription = (invoiceId: number, signal?: AbortSignal) => {
  return customFetch<CreateBillingPayPalSubscriptionResponse>({
    url: `/v1/billing/invoices/${invoiceId}/paypal_subscription`,
    method: 'POST',
    signal,
  });
};

export const getCreateBillingInvoicePaypalSubscriptionMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingInvoicePaypalSubscription>>,
    TError,
    { invoiceId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingInvoicePaypalSubscription>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['createBillingInvoicePaypalSubscription'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingInvoicePaypalSubscription>>,
    { invoiceId: number }
  > = props => {
    const { invoiceId } = props ?? {};

    return createBillingInvoicePaypalSubscription(invoiceId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/invoices/{invoiceId}/paypal_subscription` },
    {
      operationId:
        'app.controllers.billing_invoices_controller.create_billing_invoice_paypal_subscription',
      operationName: 'createBillingInvoicePaypalSubscription',
    }
  );

  return customOptions;
};

export type CreateBillingInvoicePaypalSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingInvoicePaypalSubscription>>
>;

export type CreateBillingInvoicePaypalSubscriptionMutationError = Error;

/**
 * @summary Start PayPal subscription checkout
 */
export const useCreateBillingInvoicePaypalSubscription = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBillingInvoicePaypalSubscription>>,
      TError,
      { invoiceId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createBillingInvoicePaypalSubscription>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationOptions = getCreateBillingInvoicePaypalSubscriptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Downloads an invoice as PDF using a token from the invoice details. No API login required.
 * @summary Download invoice PDF
 */
export const downloadBillingInvoicePdf = (
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  signal?: AbortSignal
) => {
  return customFetch<Blob>({
    url: `/v1/billing/invoices/${invoiceId}/pdf`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getDownloadBillingInvoicePdfQueryKey = (
  invoiceId?: number,
  params?: DownloadBillingInvoicePdfParams
) => {
  return [`/v1/billing/invoices/${invoiceId}/pdf`, ...(params ? [params] : [])] as const;
};

export const getDownloadBillingInvoicePdfQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadBillingInvoicePdfQueryKey(invoiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>> = ({
    signal,
  }) => downloadBillingInvoicePdf(invoiceId, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { invoiceId, params },
    {
      url: `/v1/billing/invoices/${invoiceId}/pdf`,
      operationId: 'app.controllers.billing_invoices_controller.download_billing_invoice_pdf',
      operationName: 'downloadBillingInvoicePdf',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadBillingInvoicePdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadBillingInvoicePdf>>
>;
export type DownloadBillingInvoicePdfQueryError = Error;

export function useDownloadBillingInvoicePdf<
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof downloadBillingInvoicePdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadBillingInvoicePdf<
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof downloadBillingInvoicePdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadBillingInvoicePdf<
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download invoice PDF
 */

export function useDownloadBillingInvoicePdf<
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadBillingInvoicePdfQueryOptions(invoiceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDownloadBillingInvoicePdfSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadBillingInvoicePdfQueryKey(invoiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>> = ({
    signal,
  }) => downloadBillingInvoicePdf(invoiceId, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { invoiceId, params },
    {
      url: `/v1/billing/invoices/${invoiceId}/pdf`,
      operationId: 'app.controllers.billing_invoices_controller.download_billing_invoice_pdf',
      operationName: 'downloadBillingInvoicePdf',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadBillingInvoicePdfSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadBillingInvoicePdf>>
>;
export type DownloadBillingInvoicePdfSuspenseQueryError = Error;

export function useDownloadBillingInvoicePdfSuspense<
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadBillingInvoicePdfSuspense<
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadBillingInvoicePdfSuspense<
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download invoice PDF
 */

export function useDownloadBillingInvoicePdfSuspense<
  TData = Awaited<ReturnType<typeof downloadBillingInvoicePdf>>,
  TError = Error,
>(
  invoiceId: number,
  params: DownloadBillingInvoicePdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadBillingInvoicePdf>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadBillingInvoicePdfSuspenseQueryOptions(invoiceId, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Lists credit cards and PayPal methods on your account. Optionally filter to the active method only.
 * @summary List payment methods
 */
export const listBillingPaymentMethods = (
  params?: ListBillingPaymentMethodsParams,
  signal?: AbortSignal
) => {
  return customFetch<BillingPaymentMethodsResponse>({
    url: `/v1/billing/payment_methods`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListBillingPaymentMethodsQueryKey = (params?: ListBillingPaymentMethodsParams) => {
  return [`/v1/billing/payment_methods`, ...(params ? [params] : [])] as const;
};

export const getListBillingPaymentMethodsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params?: ListBillingPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingPaymentMethodsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingPaymentMethods>>> = ({
    signal,
  }) => listBillingPaymentMethods(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/payment_methods`,
      operationId:
        'app.controllers.billing_payment_methods_controller.list_billing_payment_methods',
      operationName: 'listBillingPaymentMethods',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listBillingPaymentMethods>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingPaymentMethodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingPaymentMethods>>
>;
export type ListBillingPaymentMethodsQueryError = Error;

export function useListBillingPaymentMethods<
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params: undefined | ListBillingPaymentMethodsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof listBillingPaymentMethods>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingPaymentMethods<
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params?: ListBillingPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof listBillingPaymentMethods>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingPaymentMethods<
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params?: ListBillingPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List payment methods
 */

export function useListBillingPaymentMethods<
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params?: ListBillingPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingPaymentMethodsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListBillingPaymentMethodsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params?: ListBillingPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingPaymentMethodsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingPaymentMethods>>> = ({
    signal,
  }) => listBillingPaymentMethods(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/payment_methods`,
      operationId:
        'app.controllers.billing_payment_methods_controller.list_billing_payment_methods',
      operationName: 'listBillingPaymentMethods',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listBillingPaymentMethods>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingPaymentMethodsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingPaymentMethods>>
>;
export type ListBillingPaymentMethodsSuspenseQueryError = Error;

export function useListBillingPaymentMethodsSuspense<
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params: undefined | ListBillingPaymentMethodsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingPaymentMethodsSuspense<
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params?: ListBillingPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingPaymentMethodsSuspense<
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params?: ListBillingPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List payment methods
 */

export function useListBillingPaymentMethodsSuspense<
  TData = Awaited<ReturnType<typeof listBillingPaymentMethods>>,
  TError = Error,
>(
  params?: ListBillingPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingPaymentMethods>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingPaymentMethodsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Saves a credit card to your account. PayPal is set up per invoice, not here.
 * @summary Add a credit card
 */
export const createBillingPaymentMethod = (
  createBillingPaymentMethodRequest: CreateBillingPaymentMethodRequest,
  signal?: AbortSignal
) => {
  return customFetch<BillingPaymentMethodResponse>({
    url: `/v1/billing/payment_methods`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createBillingPaymentMethodRequest,
    signal,
  });
};

export const getCreateBillingPaymentMethodMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingPaymentMethod>>,
    TError,
    { data: CreateBillingPaymentMethodRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingPaymentMethod>>,
  TError,
  { data: CreateBillingPaymentMethodRequest },
  TContext
> => {
  const mutationKey = ['createBillingPaymentMethod'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingPaymentMethod>>,
    { data: CreateBillingPaymentMethodRequest }
  > = props => {
    const { data } = props ?? {};

    return createBillingPaymentMethod(data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/payment_methods` },
    {
      operationId:
        'app.controllers.billing_payment_methods_controller.create_billing_payment_method',
      operationName: 'createBillingPaymentMethod',
    }
  );

  return customOptions;
};

export type CreateBillingPaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingPaymentMethod>>
>;
export type CreateBillingPaymentMethodMutationBody = CreateBillingPaymentMethodRequest;
export type CreateBillingPaymentMethodMutationError = Error;

/**
 * @summary Add a credit card
 */
export const useCreateBillingPaymentMethod = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBillingPaymentMethod>>,
      TError,
      { data: CreateBillingPaymentMethodRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createBillingPaymentMethod>>,
  TError,
  { data: CreateBillingPaymentMethodRequest },
  TContext
> => {
  const mutationOptions = getCreateBillingPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Starts the secure card-entry flow before saving a new credit card.
 * @summary Prepare secure card entry
 */
export const createBillingPaymentMethodCreditCardSetupIntent = (signal?: AbortSignal) => {
  return customFetch<CreateBillingCreditCardSetupIntentResponse>({
    url: `/v1/billing/payment_methods/credit_card_setup_intent`,
    method: 'POST',
    signal,
  });
};

export const getCreateBillingPaymentMethodCreditCardSetupIntentMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingPaymentMethodCreditCardSetupIntent>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingPaymentMethodCreditCardSetupIntent>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['createBillingPaymentMethodCreditCardSetupIntent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingPaymentMethodCreditCardSetupIntent>>,
    void
  > = () => {
    return createBillingPaymentMethodCreditCardSetupIntent();
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/payment_methods/credit_card_setup_intent` },
    {
      operationId:
        'app.controllers.billing_payment_methods_controller.create_billing_payment_method_credit_card_setup_intent',
      operationName: 'createBillingPaymentMethodCreditCardSetupIntent',
    }
  );

  return customOptions;
};

export type CreateBillingPaymentMethodCreditCardSetupIntentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingPaymentMethodCreditCardSetupIntent>>
>;

export type CreateBillingPaymentMethodCreditCardSetupIntentMutationError = Error;

/**
 * @summary Prepare secure card entry
 */
export const useCreateBillingPaymentMethodCreditCardSetupIntent = <
  TError = Error,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBillingPaymentMethodCreditCardSetupIntent>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createBillingPaymentMethodCreditCardSetupIntent>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreateBillingPaymentMethodCreditCardSetupIntentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns details for one saved payment method, such as card type, last four digits, expiry, and linked address.
 * @summary Get payment method details
 */
export const findBillingPaymentMethod = (
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  signal?: AbortSignal
) => {
  return customFetch<BillingPaymentMethodResponse>({
    url: `/v1/billing/payment_methods/${paymentMethodId}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getFindBillingPaymentMethodQueryKey = (
  paymentMethodId?: number,
  params?: FindBillingPaymentMethodParams
) => {
  return [`/v1/billing/payment_methods/${paymentMethodId}`, ...(params ? [params] : [])] as const;
};

export const getFindBillingPaymentMethodQueryOptions = <
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindBillingPaymentMethodQueryKey(paymentMethodId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findBillingPaymentMethod>>> = ({
    signal,
  }) => findBillingPaymentMethod(paymentMethodId, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { paymentMethodId, params },
    {
      url: `/v1/billing/payment_methods/${paymentMethodId}`,
      operationId: 'app.controllers.billing_payment_methods_controller.find_billing_payment_method',
      operationName: 'findBillingPaymentMethod',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findBillingPaymentMethod>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindBillingPaymentMethodQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBillingPaymentMethod>>
>;
export type FindBillingPaymentMethodQueryError = Error;

export function useFindBillingPaymentMethod<
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params: undefined | FindBillingPaymentMethodParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findBillingPaymentMethod>>,
          TError,
          Awaited<ReturnType<typeof findBillingPaymentMethod>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingPaymentMethod<
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findBillingPaymentMethod>>,
          TError,
          Awaited<ReturnType<typeof findBillingPaymentMethod>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingPaymentMethod<
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get payment method details
 */

export function useFindBillingPaymentMethod<
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindBillingPaymentMethodQueryOptions(paymentMethodId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindBillingPaymentMethodSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindBillingPaymentMethodQueryKey(paymentMethodId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findBillingPaymentMethod>>> = ({
    signal,
  }) => findBillingPaymentMethod(paymentMethodId, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { paymentMethodId, params },
    {
      url: `/v1/billing/payment_methods/${paymentMethodId}`,
      operationId: 'app.controllers.billing_payment_methods_controller.find_billing_payment_method',
      operationName: 'findBillingPaymentMethod',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findBillingPaymentMethod>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindBillingPaymentMethodSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findBillingPaymentMethod>>
>;
export type FindBillingPaymentMethodSuspenseQueryError = Error;

export function useFindBillingPaymentMethodSuspense<
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params: undefined | FindBillingPaymentMethodParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingPaymentMethodSuspense<
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindBillingPaymentMethodSuspense<
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get payment method details
 */

export function useFindBillingPaymentMethodSuspense<
  TData = Awaited<ReturnType<typeof findBillingPaymentMethod>>,
  TError = Error,
>(
  paymentMethodId: number,
  params?: FindBillingPaymentMethodParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findBillingPaymentMethod>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindBillingPaymentMethodSuspenseQueryOptions(
    paymentMethodId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Permanently removes a saved payment method from your account.
 * @summary Remove a payment method
 */
export const deleteBillingPaymentMethod = (paymentMethodId: number) => {
  return customFetch<SuccessResponse>({
    url: `/v1/billing/payment_methods/${paymentMethodId}`,
    method: 'DELETE',
  });
};

export const getDeleteBillingPaymentMethodMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBillingPaymentMethod>>,
    TError,
    { paymentMethodId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBillingPaymentMethod>>,
  TError,
  { paymentMethodId: number },
  TContext
> => {
  const mutationKey = ['deleteBillingPaymentMethod'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBillingPaymentMethod>>,
    { paymentMethodId: number }
  > = props => {
    const { paymentMethodId } = props ?? {};

    return deleteBillingPaymentMethod(paymentMethodId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/payment_methods/{paymentMethodId}` },
    {
      operationId:
        'app.controllers.billing_payment_methods_controller.delete_billing_payment_method',
      operationName: 'deleteBillingPaymentMethod',
    }
  );

  return customOptions;
};

export type DeleteBillingPaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBillingPaymentMethod>>
>;

export type DeleteBillingPaymentMethodMutationError = Error;

/**
 * @summary Remove a payment method
 */
export const useDeleteBillingPaymentMethod = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBillingPaymentMethod>>,
      TError,
      { paymentMethodId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBillingPaymentMethod>>,
  TError,
  { paymentMethodId: number },
  TContext
> => {
  const mutationOptions = getDeleteBillingPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates a credit card's description, billing address, expiry, or whether it is the default for auto-pay.
 * @summary Update a payment method
 */
export const modifyBillingPaymentMethod = (
  paymentMethodId: number,
  updateBillingPayMethodRequest: UpdateBillingPayMethodRequest
) => {
  return customFetch<BillingPaymentMethodResponse>({
    url: `/v1/billing/payment_methods/${paymentMethodId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateBillingPayMethodRequest,
  });
};

export const getModifyBillingPaymentMethodMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modifyBillingPaymentMethod>>,
    TError,
    { paymentMethodId: number; data: UpdateBillingPayMethodRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modifyBillingPaymentMethod>>,
  TError,
  { paymentMethodId: number; data: UpdateBillingPayMethodRequest },
  TContext
> => {
  const mutationKey = ['modifyBillingPaymentMethod'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modifyBillingPaymentMethod>>,
    { paymentMethodId: number; data: UpdateBillingPayMethodRequest }
  > = props => {
    const { paymentMethodId, data } = props ?? {};

    return modifyBillingPaymentMethod(paymentMethodId, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/billing/payment_methods/{paymentMethodId}` },
    {
      operationId:
        'app.controllers.billing_payment_methods_controller.modify_billing_payment_method',
      operationName: 'modifyBillingPaymentMethod',
    }
  );

  return customOptions;
};

export type ModifyBillingPaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof modifyBillingPaymentMethod>>
>;
export type ModifyBillingPaymentMethodMutationBody = UpdateBillingPayMethodRequest;
export type ModifyBillingPaymentMethodMutationError = Error;

/**
 * @summary Update a payment method
 */
export const useModifyBillingPaymentMethod = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof modifyBillingPaymentMethod>>,
      TError,
      { paymentMethodId: number; data: UpdateBillingPayMethodRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof modifyBillingPaymentMethod>>,
  TError,
  { paymentMethodId: number; data: UpdateBillingPayMethodRequest },
  TContext
> => {
  const mutationOptions = getModifyBillingPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Lists purchasable hosting plans with pricing by billing cycle. Filter by plan type or coupon. Add-ons are not included.
 * @summary List available hosting plans
 */
export const listBillingProducts = (params?: ListBillingProductsParams, signal?: AbortSignal) => {
  return customFetch<BillingProductsResponse>({
    url: `/v1/billing/products`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListBillingProductsQueryKey = (params?: ListBillingProductsParams) => {
  return [`/v1/billing/products`, ...(params ? [params] : [])] as const;
};

export const getListBillingProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params?: ListBillingProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingProducts>>> = ({ signal }) =>
    listBillingProducts(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/products`,
      operationId: 'app.controllers.billing_controller.list_billing_products',
      operationName: 'listBillingProducts',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listBillingProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingProducts>>
>;
export type ListBillingProductsQueryError = Error;

export function useListBillingProducts<
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params: undefined | ListBillingProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingProducts>>,
          TError,
          Awaited<ReturnType<typeof listBillingProducts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingProducts<
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params?: ListBillingProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBillingProducts>>,
          TError,
          Awaited<ReturnType<typeof listBillingProducts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingProducts<
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params?: ListBillingProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List available hosting plans
 */

export function useListBillingProducts<
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params?: ListBillingProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingProductsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListBillingProductsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params?: ListBillingProductsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBillingProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBillingProducts>>> = ({ signal }) =>
    listBillingProducts(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/billing/products`,
      operationId: 'app.controllers.billing_controller.list_billing_products',
      operationName: 'listBillingProducts',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listBillingProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBillingProductsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBillingProducts>>
>;
export type ListBillingProductsSuspenseQueryError = Error;

export function useListBillingProductsSuspense<
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params: undefined | ListBillingProductsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingProductsSuspense<
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params?: ListBillingProductsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBillingProductsSuspense<
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params?: ListBillingProductsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List available hosting plans
 */

export function useListBillingProductsSuspense<
  TData = Awaited<ReturnType<typeof listBillingProducts>>,
  TError = Error,
>(
  params?: ListBillingProductsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listBillingProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBillingProductsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
